import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUpIcon, TargetIcon } from 'lucide-react';
export function RiskReversal() {
  return <section className="py-16 px-6 bg-gradient-to-br from-[var(--viridia-green)] to-[var(--deep-teal)]" data-id="element-229">
      <div className="max-w-4xl mx-auto" data-id="element-230">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-231">
          <TrendingUpIcon className="w-16 h-16 text-white mx-auto mb-6" data-id="element-232" />
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-233">
            Maximize Your Results
          </h2>
          <div className="bg-white rounded-xl p-8 shadow-2xl" data-id="element-234">
            <div className="flex items-start gap-4 mb-6" data-id="element-235">
              <TargetIcon className="w-8 h-8 text-[var(--viridia-green)] flex-shrink-0 mt-1" data-id="element-236" />
              <div className="text-left" data-id="element-237">
                <h3 className="text-xl font-bold text-[var(--jet-black)] mb-3" data-id="element-238">
                  Best Results with Local Advertising
                </h3>
                <p className="text-lg text-[var(--graphite-gray)] leading-relaxed mb-4" data-id="element-239">
                  Our automation system delivers the highest ROI when paired
                  with local advertising campaigns. Whether you're running
                  Google Ads, Facebook Ads, or investing in local SEO, instant
                  AI responses ensure you capture every lead.
                </p>
                <div className="bg-[var(--white-smoke)] rounded-lg p-4 border-l-4 border-[var(--viridia-green)]" data-id="element-240">
                  <p className="text-sm text-[var(--graphite-gray)]" data-id="element-241">
                    <strong className="text-[var(--jet-black)]" data-id="element-242">
                      Pro Tip:
                    </strong>{' '}
                    Clients who combine our service with paid advertising see
                    3-5x better conversion rates compared to ads alone. Every
                    dollar you spend on ads works harder when leads get instant
                    responses.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}